import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Button,
  FormControl,
  Grid,
  LinearProgress,
  Paper,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import InventoryIcon from "@mui/icons-material/Inventory";
import PaidIcon from "@mui/icons-material/Paid";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import MainContainer from "../../layout/MainContainer";
import { GetDashboard } from "../../services/home";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#ffffff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  borderRadius: "16px",
  border: "1px solid #f1f5f9",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
    transform: "translateY(-2px)",
  },
}));

type Dashboard = {
  postCountPrevious: number;
  postCount: number;
  userCountPrevious: number;
  userCount: number;
  subscriptionCount: number;
  subscriptionCountPrevious: number;
};

const DashBoard = () => {
  const [opened, setOpened] = useState<boolean>(false);
  const [filterBy, setFilterBy] = useState("Daily");
  const [dashboardData, setDashboardData] = useState<Dashboard>({
    postCount: 0,
    postCountPrevious: 0,
    subscriptionCount: 0,
    subscriptionCountPrevious: 0,
    userCount: 0,
    userCountPrevious: 0,
  });

  const getDashboard = async () => {
    try {
      const response = (await GetDashboard({ filterBy })) as {
        code: number;
        data: Dashboard;
      };
      if (response?.code === 200) {
        setDashboardData({
          ...dashboardData,
          postCount: response?.data?.postCount || 0,
          postCountPrevious: response?.data?.postCountPrevious || 0,
          userCount: response?.data?.userCount || 0,
          userCountPrevious: response?.data?.userCountPrevious || 0,
          subscriptionCount: response?.data?.subscriptionCount || 0,
          subscriptionCountPrevious:
            response?.data?.subscriptionCountPrevious || 0,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const showNow = () => {
    switch (filterBy) {
      case "Daily":
        return "today";
      case "Weekly":
        return "this week";
      case "Monthly":
        return "this month";
      case "Yearly":
        return "this year";
      default:
        break;
    }
  };

  const showPast = () => {
    switch (filterBy) {
      case "Daily":
        return "Yesterday";
      case "Weekly":
        return "Past week";
      case "Monthly":
        return "Past month";
      case "Yearly":
        return "Past year";
      default:
        break;
    }
  };

  useEffect(() => {
    getDashboard();
  }, [filterBy]);

  return (
    <MainContainer>
      <div className="main_loyout" onClick={() => setOpened(false)}>
        <div className="dashboard">
          <h1 className="mn_hdng">Dashboard</h1>
        </div>

        <Grid
          container
          spacing={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Grid item></Grid>
          <Grid item>
            <div className="parent-box">
              <Button
                onClick={(e: any) => {
                  e.stopPropagation();
                  setOpened(true);
                }}
                id="basic-button"
                variant="contained"
                sx={{
                  background: "linear-gradient(135deg, #1B154A 0%, #2a2366 100%)",
                  boxShadow: "0 4px 14px 0 rgba(27, 21, 74, 0.25)",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  padding: "10px 20px",
                  "&:hover": {
                    background: "linear-gradient(135deg, #2a2366 0%, #1B154A 100%)",
                    boxShadow: "0 6px 20px rgba(27, 21, 74, 0.35)",
                  },
                }}
              >
                Filter stats
              </Button>
              {opened ? (
                <div
                  onClick={(e) => e.stopPropagation()}
                  className="filter-options"
                >
                  <h3>Filter Options</h3>
                  <div className="filter-div">
                    <FormControl fullWidth>
                      <label>Period</label>
                      <select
                        onChange={(val) => {
                          setFilterBy(val.target.value);
                          setOpened(false);
                        }}
                        value={filterBy}
                        name="cars"
                        id="cars"
                      >
                        <option value="Daily">By Today</option>
                        <option value="Weekly">Last 7 days</option>
                        <option value="Monthly">Last 30 days</option>
                        <option value="Yearly">Last year</option>
                      </select>
                    </FormControl>
                  </div>
                </div>
              ) : null}
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={2} className="dashGrid">
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Item className="cards dashGrid_item ">
              <Box className="upr_items">
                <PeopleIcon className="svg_icn" />
                <div>
                  <h3>Total Users</h3>
                  <h4 className="mn_hdng">{dashboardData?.userCount || 0}</h4>
                  <p>New users {showNow()}</p>
                </div>
              </Box>
              <Box display={"flex"} justifyContent={"space-between"}>
                <p>{showPast()}</p>
                <p>{dashboardData?.userCountPrevious || 0}</p>
              </Box>
              <LinearProgress
                sx={{
                  width: "100%",
                  height: 6,
                  borderRadius: 3,
                  backgroundColor: "#e2e8f0",
                  "& .MuiLinearProgress-bar": {
                    borderRadius: 3,
                    background: "linear-gradient(90deg, #FED600 0%, #e6c200 100%)",
                  },
                }}
                variant="determinate"
                value={40}
              />
            </Item>
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Item className="cards dashGrid_item ">
              <Box className="upr_items">
                <InventoryIcon className="svg_icn" />
                <div>
                  <h3>Total posts</h3>
                  <h4 className="mn_hdng">{dashboardData?.postCount || 0}</h4>
                  <p>New Posts {showNow()}</p>
                </div>
              </Box>
              <Box display={"flex"} justifyContent={"space-between"}>
                <p>{showPast()}</p>
                <p>{dashboardData?.postCountPrevious || 0}</p>
              </Box>
              <LinearProgress
                sx={{
                  width: "100%",
                  height: 6,
                  borderRadius: 3,
                  backgroundColor: "#e2e8f0",
                  "& .MuiLinearProgress-bar": {
                    borderRadius: 3,
                    background: "linear-gradient(90deg, #FED600 0%, #e6c200 100%)",
                  },
                }}
                variant="determinate"
                value={60}
              />
            </Item>
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Item className="cards dashGrid_item ">
              <Box className="upr_items">
                <PaidIcon className="svg_icn" />
                <div>
                  <h3>Total subscriptions</h3>
                  <h4 className="mn_hdng">
                    {dashboardData?.subscriptionCount || 0}
                  </h4>
                  <p>New subscriptions {showNow()}</p>
                </div>
              </Box>
              <Box display={"flex"} justifyContent={"space-between"}>
                <p>{showPast()}</p>
                <p>{dashboardData?.subscriptionCountPrevious || 0}</p>
              </Box>
              <LinearProgress
                sx={{
                  width: "100%",
                  height: 6,
                  borderRadius: 3,
                  backgroundColor: "#e2e8f0",
                  "& .MuiLinearProgress-bar": {
                    borderRadius: 3,
                    background: "linear-gradient(90deg, #FED600 0%, #e6c200 100%)",
                  },
                }}
                variant="determinate"
                value={30}
              />
            </Item>
          </Grid>
        </Grid>
      </div>
    </MainContainer>
  );
};

export default DashBoard;
